<template>
  <div class="page page--company-bills">
    <div class="page__title">
      <div class="page__title-icon">
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="27" height="27" rx="8" fill="#64748B" />
          <path
            d="M17.4 7.08193L16.5 8.21931L15.225 7.08193C15.1602 7.0288 15.0812 7.00004 15 7.00004C14.9188 7.00004 14.8398 7.0288 14.775 7.08193L13.5 8.21931L12.225 7.08193C12.1602 7.0288 12.0812 7.00004 12 7.00004C11.9188 7.00004 11.8398 7.0288 11.775 7.08193L10.5 8.21931L9.6 7.08193C9.35156 6.88136 9 7.07177 9 7.40689V19.5931C9 19.9282 9.35156 20.1186 9.6 19.9181L10.5 18.7807L11.775 19.9181C11.8398 19.9712 11.9188 20 12 20C12.0812 20 12.1602 19.9712 12.225 19.9181L13.5 18.7807L14.775 19.9181C14.8398 19.9712 14.9188 20 15 20C15.0812 20 15.1602 19.9712 15.225 19.9181L16.5 18.7807L17.4 19.9181C17.6461 20.1186 18 19.9282 18 19.5931V7.40689C18 7.07177 17.6484 6.88136 17.4 7.08193V7.08193ZM16.5 16.1403C16.5 16.2521 16.4156 16.3435 16.3125 16.3435H10.6875C10.5844 16.3435 10.5 16.2521 10.5 16.1403V15.7341C10.5 15.6224 10.5844 15.531 10.6875 15.531H16.3125C16.4156 15.531 16.5 15.6224 16.5 15.7341V16.1403ZM16.5 13.7031C16.5 13.8148 16.4156 13.9062 16.3125 13.9062H10.6875C10.5844 13.9062 10.5 13.8148 10.5 13.7031V13.2969C10.5 13.1852 10.5844 13.0938 10.6875 13.0938H16.3125C16.4156 13.0938 16.5 13.1852 16.5 13.2969V13.7031ZM16.5 11.2659C16.5 11.3776 16.4156 11.469 16.3125 11.469H10.6875C10.5844 11.469 10.5 11.3776 10.5 11.2659V10.8597C10.5 10.7479 10.5844 10.6565 10.6875 10.6565H16.3125C16.4156 10.6565 16.5 10.7479 16.5 10.8597V11.2659Z"
            fill="white"
          />
        </svg>
      </div>
      <div class="page__title-text">{{ $t('bills.page.title') }}</div>
    </div>
    <div class="bills-view-switcher">
      <div
        class="bills-view-switcher__item"
        :class="{ active: currentView === 'bills' }"
        @click="switchView('bills')"
      >
        {{ $t('bills.page.view-switcher.bills') }}
      </div>
      <div
        class="bills-view-switcher__item"
        :class="{ active: currentView === 'registry' }"
        @click="switchView('registry')"
      >
        {{ $t('bills.page.view-switcher.registry') }}
      </div>
      <require-access action="read" data="bills-template-view">
        <div
          class="bills-view-switcher__item"
          :class="{ active: currentView === 'templates' }"
          @click="switchView('templates')"
        >
          {{ $t('bills.page.view-switcher.templates') }}
        </div>
      </require-access>
    </div>
    <component :is="currentViewComponent"></component>
  </div>
</template>

<script>
import BillListPage from '@vue-app/views/company/Bills/SubPages/BillListPage.vue'
import BillTemplatesPage from '@vue-app/views/company/Bills/SubPages/BillTemplatesPage.vue'
import BillsRegistry from '@vue-app/views/company/Bills/ByRegistry/BillsRegistry.vue'
import BillRegistriesPage from '@vue-app/views/company/Bills/SubPages/BillRegistriesPage.vue'
import RequireAccess from '@vue-app/components/base/role-based/RequireAccess.vue'

export default {
  name: 'CompanyBills',
  components: {
    RequireAccess,
    BillListPage,
    BillTemplatesPage,
    BillsRegistry,
    BillRegistriesPage,
  },
  props: {
    id: {
      required: true,
    },
  },
  data() {
    return {
      currentView: 'bills',
    }
  },
  created() {
    this.currentView = this.$route.hash
      ? this.$route.hash.replace('#', '')
      : 'bills'
  },
  computed: {
    currentViewComponent() {
      return this.currentView === 'bills'
        ? 'BillListPage'
        : this.currentView === 'templates'
        ? 'BillTemplatesPage'
        : 'BillRegistriesPage'
    },
  },
  methods: {
    switchView(view) {
      this.currentView = view
      location.hash = view
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  &--company-bills {
    margin-top: 30px;
  }

  &__title {
    display: flex;
    align-items: center;

    &-icon {
      margin-right: 13px;
      width: 27px;
      height: 27px;

      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    &-text {
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
      display: flex;
      align-items: center;
      color: #585f6d;
    }
  }
}
.bills-view-switcher {
  margin-top: 35px;
  margin-bottom: 30px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eff2f8;
  display: flex;
  align-items: center;
  &__item {
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;
    color: #67768a;
    opacity: 0.7;

    position: relative;
    padding: 0 10px;
    margin-right: 14px;
    cursor: pointer;

    &:hover {
      opacity: 0.6;
    }

    &:last-child {
      margin-right: 0;
    }

    &.active {
      font-weight: 600;
      font-size: 16px;
      line-height: 28px;
      color: #465a8b;
      opacity: 1;

      &:after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        bottom: -15px;
        background: #64748B;
        border-radius: 8px;
        width: 100%;
        height: 5px;
      }
    }
  }
}
</style>
